import { OrganizationsManagement } from 'pages/organizations';

import { Unauthorized } from 'components/unauthorized';

import { useCanAccess } from 'hooks/useCanAccess';
import { TokenExpired } from 'components/tokenExpired';

export const OrganizationManagementRoute = () => {
  const { isAdmin, isExpired } = useCanAccess('organizations');
  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <OrganizationsManagement />
  ) : (
    <Unauthorized />
  );
};
